import React, { Component } from 'react';
import { GenericOption, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';

class PopUpPrograma extends Component {
    constructor(props) {
        super(props);

        this.state = {
            categorySelected: ""
        }
    }

    programaSelectedSave = (categorySelected) => {
        let categoryId = (categorySelected && (typeof categorySelected == "number") ) ? categorySelected : this.props.productos.categorySelected;
        this.props.programaSelectedSave(this.props.productos.productoId, categoryId, this.props.userId, this.props.productos.startUpSelected);
    }

    programSelectionCancel = () => {
        this.props.programSelectionCancel(this.props.productos.productoId, this.props.userId, this.props.productos.startUpSelected);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            categorySelected: nextProps.productos.categorySelected ? nextProps.productos.categorySelected : 0
        });

        if (nextProps.productos.categorySelected && nextProps.productos.defaultPrograma) {
            this.programaSelectedSave(nextProps.productos.categorySelected);
        }

        let product = nextProps.productos.menuUsuario.filter(x => x.id == this.props.productos.productoId);

        if (product && product.length > 0)
            this.setState({ productoNombre: product[0].codigo});
    }

    clean = () => {
        this.setState({ productoId: ""});
    }

    programaSelected = (e) => {
        this.props.programaSelected(e);
    }
    
    render() {
        const { props } = this;

        let selec;
        let programs = this.props.productos.programCategories;

        let oProgramas = programs.map((program) => {
            selec = program.id == this.state.categorySelected ? true : false;
            return (<div className="row row-radio">
                <div className="left-separator-xs panel panel-view">
                    <div className="container-radio-popup radio-margin panel-view-radio">
                        <input id={"NewProduct_" + program.id} type="radio" name="groupX1" checked={selec} />
                        <label className="lbl-radio label-secondary panel-view-label level-auxiliary" onClick={() => this.programaSelected(program.id)}>
                            <p>{program.descripcion}</p>
                            <span> </span>
                        </label>
                    </div>
                </div>
            </div>)
        });

        return (
            <div className="modal fade-out" id="programaModal" role="dialog" data-backdrop="static">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header modal-header-onboarding" data-label="Título">
                            <h4 className="modal-title">Seleccione su programa de inicio</h4>
                            <h5>Perfecto! Ahora por favor seleccione una categoría. A partir de dicha selección se establecerá el primer programa de la categoría como predeterminado, apareciendo cada vez que inicie sesión en {this.state.productoNombre}:</h5>
                        </div>

                        <div className="modal-body modal-perfiles-body">
                            <div className="row">
                                {oProgramas}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <div className="row">
                                <div className="col-xs-5">
                                    <button type="button"
                                        className="btn btn-primary btn-cta"
                                        onClick={this.programaSelectedSave}>Seleccionar</button>
                                </div>

                                <div className="col-xs-7">
                                    <button type="button"
                                        className="btn btn-default btn-secondary"
                                        onClick={this.programSelectionCancel}>En otro momento</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default PopUpPrograma;








// WEBPACK FOOTER //
// ./Portico/App/Screens/TopMenu/PopUpPrograma.jsx